// Create
export const PAGE_ID_CREATE = 'create';
export const PAGE_ID_CLASSIFY = 'classify';
export const PAGE_ID_MANAGE = 'manage';
export const PAGE_ID_PAY_AND_POST = 'payAndPost';
export const PAGE_ID_PAY_AND_POST_V2 = 'payAndPostV2';
export const PAGE_ID_SELECT_AD_TYPE = 'selectAdType';
export const PAGE_ID_SUCCESS = 'success';
export const PAGE_ID_WRITE = 'write';
export const PAGE_ID_CONCIERGE = 'concierge';
export const PAGE_ID_GUARANTEED_HIRE = 'guaranteed-hire';
export const PAGE_ID_PREMIUM_PLUS = 'premium-plus';
export const PAGE_ID_MULTI_LOCATION = 'multiLocation';

// Edit
export const PAGE_ID_EDIT = 'edit';
export const PAGE_ID_EDIT_PAY_AND_POST = 'editPayAndPost';
export const PAGE_ID_EDIT_SUCCESS = 'editSuccess';

// Refresh
export const PAGE_ID_REFRESH = 'refresh';
export const PAGE_ID_REFRESH_SUCCESS = 'refreshSuccess';
export const PAGE_ID_REFRESH_ERROR = 'refreshError';

// Misc
export const PAGE_ID_TEST_PAGE = 'testPage'; // Page for a testing components in prod/stag env

// used in ProgressBar and pageUtils to handle create step navigation
// MUST be in order of create flow pages
export const createFlowPageIds = [
  PAGE_ID_CLASSIFY,
  PAGE_ID_SELECT_AD_TYPE,
  PAGE_ID_WRITE,
  PAGE_ID_MANAGE,
  PAGE_ID_PAY_AND_POST,
  PAGE_ID_SUCCESS,
];

// used in PromoCodeBanner to show promo codes
export const showPromoCodePageIds = [
  PAGE_ID_CLASSIFY,
  PAGE_ID_SELECT_AD_TYPE,
  PAGE_ID_WRITE,
  PAGE_ID_MANAGE,
];
